import i18n from '../../language/index'
import store from '@/vuex/store'
export function basic_navbar_create_style_obj(){
  return[
    {
    id: '0',
    name: i18n.t('widgets_basic_navbar_patternchildstyle_2661'),
    imgUrl: '',
    typeStyle:'noLogo',
    data: {
      styleType: 'type_0',
      navfont: {
        default: {
          fontSeColor: store.state.myRender.common.theme_color,
        },
      },
      border: {
        radio_val: 'default',
        default: {
          borderSeColor: store.state.myRender.common.theme_color,
        },
      },
      navChildfont: {
        default: {
          fontSeColor: store.state.myRender.common.theme_color,
        },
      },
    },
  },
    {
    id: '1',
    name: i18n.t('widgets_basic_navbar_patternchildstyle_2662'),
    imgUrl: '/static/images/styleImg/navStyle0.png',
    typeStyle:'noLogo',
    data: {
      styleType: 'type_1',
      border: {
        radio_val: 'default',
        default: {
          borderSeColor: store.state.myRender.common.theme_color,
        },
      },
      navChildfont: {
        default: {
          fontColor: store.state.myRender.common.theme_color,
        },
      },
    },
  },
    {
    id: '2',
    name: i18n.t('widgets_basic_navbar_patternchildstyle_2663'),
    imgUrl: '/static/images/styleImg/navStyle1.png',
    typeStyle:'noLogo',
    data: {
      styleType: 'type_2',
      border: {
        radio_val: 'default',
        default: {
          borderSeColor: store.state.myRender.common.theme_color,
        },
      },
      navSeBackground: {
        default: {
          color: store.state.myRender.common.theme_color, // 背景设置-颜色
        }
      },
      navChildfont: {
        default: {
          fontColor: store.state.myRender.common.theme_color,
          fontSeColor: store.state.myRender.common.theme_color,
        },
      },
    },
  },
    {
    id: '3',
    name: i18n.t('widgets_basic_navbar_patternstyle_2665'),
    imgUrl: '/static/images/styleImg/navStyle2.png',
    typeStyle:'noLogo',
    data: {
      styleType: 'type_3',
      navfont: {
        default: {
          fontSeColor: store.state.myRender.common.theme_color,
        },
      },
      border: {
        radio_val: 'default',
        default: {
          borderSeColor: store.state.myRender.common.theme_color,
        },
      },
      navChildfont: {
        default: {
          fontColor: store.state.myRender.common.theme_color,
          fontSeColor: store.state.myRender.common.theme_color,
        },
      },
    },
  },
    {
    id: '4',
    name: i18n.t('widgets_basic_navbar_patternchildstyle_2664'),
    imgUrl: '/static/images/styleImg/navStyle3.png',
    typeStyle:'noLogo',
    data: {
      styleType: 'type_4',
      navfont: {
        default: {
          fontSeColor: store.state.myRender.common.theme_color,
        },
      },
      border: {
        radio_val: 'default',
        default: {
          borderSeColor: store.state.myRender.common.theme_color,
        },
      },
      navChildfont: {
        default: {
          fontColor: store.state.myRender.common.theme_color,
          fontSeColor: store.state.myRender.common.theme_color,
        },
      },
    },
  },
    {
    id: '5',
    name: i18n.t('widgets_basic_navbar_patternstyle_2666'),
    imgUrl: '/static/images/styleImg/navStyle4.png',
    typeStyle:'noLogo',
    data: {
      styleType: 'type_5',
      showLine: 'true',
      navfont: {
        default: {
          fontSeColor: store.state.myRender.common.theme_color,
        },
      },
      border: {
        radio_val: 'default',
        default: {
          borderSeColor: store.state.myRender.common.theme_color,
        },
      },
      navChildfont: {
        default: {
          fontColor: store.state.myRender.common.theme_color,
          fontSeColor: store.state.myRender.common.theme_color,
      },
    },
  },
},

    {
    id: '6',
    name: i18n.t('widgets_basic_navbar_patternstyle_2667'),
    imgUrl: '/static/images/styleImg/navStyle5.png',
    typeStyle:'noLogo',
    data: {
      styleType: 'type_6',
      showLine: 'true',
      navfont: {
        default: {
          fontSeColor: store.state.myRender.common.theme_color,
        },
      },
      border: {
        radio_val: 'default',
        default: {
          borderSeColor: store.state.myRender.common.theme_color,
        },
      },
      navChildfont: {
        default: {
          fontColor: store.state.myRender.common.theme_color,
          fontSeColor: store.state.myRender.common.theme_color,
        },
      },
    },
  },
    {
    id: '0',
    name: i18n.t('widgets_basic_navbar_patternstyle_2669'),
    imgUrl: '/static/images/styleImg/navStyle20.png',
    typeStyle:'logo',
    data: {
      styleType: 'type_7',
      border: {
        radio_val: 'default',
        default: {
          borderSeColor: store.state.myRender.common.theme_color,
        },
      },
      navSeBackground: {
        default: {
          color: store.state.myRender.common.theme_color, // 背景设置-颜色
        }
      },
      navChildfont: {
        default: {
          fontColor: store.state.myRender.common.theme_color,
        },
      },
    },
  },
    {
    id: '1',
    name: i18n.t('widgets_basic_navbar_patternstyle_2670'),
    imgUrl: '/static/images/styleImg/navStyle21.png',
    typeStyle:'logo',
    data: {
      styleType: 'type_8',
      border: {
        radio_val: 'default',
        default: {
          borderSeColor: store.state.myRender.common.theme_color,
        },
      },
      navSeBackground: {
        default: {
          color: store.state.myRender.common.theme_color, // 背景设置-颜色
      },
      navChildfont: {
        default: {
          fontColor: store.state.myRender.common.theme_color,
          fontSeColor: store.state.myRender.common.theme_color,
        },
      },
    },
  },
},
    {
    id: '2',
    name: i18n.t('widgets_basic_navbar_patternstyle_2671'),
    imgUrl: '/static/images/styleImg/navStyle22.png',
    typeStyle:'logo',
    data: {
      styleType: 'type_9',
      navfont: {
        default: {
          fontSeColor: store.state.myRender.common.theme_color,
        },
      },
      border: {
        radio_val: 'default',
        default: {
          borderSeColor: store.state.myRender.common.theme_color,
        },
      },
      navChildfont: {
        default: {
          fontColor: store.state.myRender.common.theme_color,
          fontSeColor: store.state.myRender.common.theme_color,
        },
      },
    },
  },
    {
    id: '3',
    name: i18n.t('widgets_basic_navbar_patternstyle_2672'),
    imgUrl: '/static/images/styleImg/navStyle23.png',
    typeStyle:'logo',
    data: {
      styleType: 'type_10',
      navfont: {
        default: {
          fontSeColor: store.state.myRender.common.theme_color,
        },
      },
      border: {
        radio_val: 'default',
        default: {
          borderSeColor: store.state.myRender.common.theme_color,
        },
      },
      navChildfont: {
        default: {
          fontColor: store.state.myRender.common.theme_color,
          fontSeColor: store.state.myRender.common.theme_color,
        },
      },
    },
  },
    {
    id: '4',
    name: i18n.t('widgets_basic_navbar_patternstyle_2673'),
    imgUrl: '/static/images/styleImg/navStyle24.png',
    typeStyle:'logo',
    data: {
      styleType: 'type_11',
      showLine: 'true',
      navfont: {
        default: {
          fontSeColor: store.state.myRender.common.theme_color,
        },
      },
      border: {
        radio_val: 'default',
        default: {
          borderSeColor: store.state.myRender.common.theme_color,
        },
      },
      navChildfont: {
        default: {
          fontColor: store.state.myRender.common.theme_color,
          fontSeColor: store.state.myRender.common.theme_color,
        },
      },
    },
  },
    {
    id: '5',
    name: i18n.t('widgets_basic_navbar_patternstyle_2674'),
    imgUrl: '/static/images/styleImg/navStyle25.png',
    typeStyle:'logo',
    data: {
      styleType: 'type_12',
      showLine: 'true',
      navfont: {
        default: {
          fontSeColor: store.state.myRender.common.theme_color,
        },
      },
      border: {
        radio_val: 'default',
        default: {
          borderSeColor: store.state.myRender.common.theme_color,
        },
      },
      navChildfont: {
        default: {
          fontColor: store.state.myRender.common.theme_color,
          fontSeColor: store.state.myRender.common.theme_color,
        },
      },
    },
  }
  ]
}



// WEBPACK FOOTER //
// ./src/widgets/basic_navbar/patternStyleClear.js